import clsx from 'clsx';

import styles from './CountryListItem.module.scss';

type CountryListItemProps = {
  code: string;
  name: string;
  selected?: boolean;
};

const CountryListItem = ({ code, name, selected }: CountryListItemProps) => {
  return (
    <span className={clsx(styles.countryItem, selected && styles.selected)}>
      <span className={styles.countryCode}>{code}</span>
      <span className={styles.countryName}>{name}</span>
    </span>
  );
};

export default CountryListItem;
